import React, { useState } from 'react';
import { BsGithub } from "react-icons/bs";
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillYoutube } from "react-icons/ai";
import { Link } from 'react-router-dom';

const Navigation = () => {
    const [showPhoneMenu, setShowPhoneMenu] = useState(false);

    return (
        <nav className="border-b shadow-md sticky top-0 z-50 w-full bg-white border-gray-200 px-2 sm:px-4 py-2.5 rounded dark:bg-gray-900">
            <div className="container flex flex-wrap items-center justify-between mx-auto">
                <a href="/" className="flex items-center">
                    <span className='text-primary font-inter font-semibold'>{".{/"} Mahbub {"/}"}</span>
                    {/* <span className="text-purple-700 font-rubik text-xl font-extrabold">{"{"}</span>
                    <span className="text-purple-700 font-rubik text-2xl font-extrabold">Munir Uddin</span>
                    <span className="text-primary font-rubik text-2xl font-extrabold">&nbsp;Mahbub</span>
                    <span className="text-primary font-rubik text-xl font-extrabold">{"</>"}</span> */}
                </a>
                <button
                    onClick={() => setShowPhoneMenu(!showPhoneMenu)}
                    type="button"
                    className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                >
                    <span className="sr-only">Open main menu</span>
                    <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg>
                </button>
                <div className={showPhoneMenu ? "w-full md:block md:w-auto" : "hidden w-full md:block md:w-auto"} id="navbar-default">
                    <div className="md:flex">
                        <ul className="flex flex-col p-4 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                            <li>
                                <Link to="/" className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white" aria-current="page">Home</Link>
                            </li>
                            <li>
                                <Link to="/blogs" className="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Blogs</Link>
                            </li>
                            <li>
                                <Link to="/service" className="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Services</Link>
                            </li>
                            <li>
                                <Link to="/projects" className="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Projects</Link>
                            </li>
                            <li>
                                <Link to="/contact" className="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Contact</Link>
                            </li>
                        </ul>
                        <div className='flex gap-1 items-center'>
                            <a href="https://github.com/mahbub-hasan2" target="_blank" rel="noopener noreferrer" className='rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 p-2' >
                                <BsGithub className="text-2xl" />
                            </a>
                            <a href="https://linkedin.com/in/mahbubdev1" target="_blank" rel="noopener noreferrer" className='rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 p-2' >
                                <AiFillLinkedin className="text-2xl" />
                            </a>
                            <a href="https://youtube.com/@mahbubdev" target="_blank" rel="noopener noreferrer" className='rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 p-2' >
                                <AiFillYoutube className="text-2xl" />
                            </a>
                        </div>
                        <div className="flex items-center ml-4">
                            <a
                                href="https://drive.google.com/file/d/1zsPsX3IMfcf1EacJMU6U5_M-H6pSLrO3/view?usp=sharing"
                                target="_blank"
                                rel="noopener noreferrer"
                                className='bg-primary text-white py-2 px-4 rounded-lg font-poppins hover:bg-blue-800'
                            >My Resume</a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;